export default __webpack_public_path__ + "static/kinekt-new-case-5951eff9c38e2016207aa6fb366b416c.webp";